import { render, staticRenderFns } from "./ReadEditSelect.vue?vue&type=template&id=282c3195&scoped=true&"
import script from "./ReadEditSelect.vue?vue&type=script&lang=ts&"
export * from "./ReadEditSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ReadEditSelect.vue?vue&type=style&index=0&id=282c3195&scoped=true&lang=scss&"
import style1 from "./ReadEditSelect.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c3195",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
